import { BehaviorSubject, Observable } from 'rxjs';
import { CollectionViewer, DataSource } from '@angular/cdk/collections';
import { InternalEquipmentFilterPerformance } from './internalEquipment';
import { catchError, finalize } from 'rxjs/operators';

import { InternalEquipmentService } from '../services/internalEquipment.service';
import { of } from 'rxjs';
import { InternalEquipmentPerformancesShort } from './internalEquipmentPerformancesShort';

export class InternalEquipmentPerformancesDataSource implements DataSource<InternalEquipmentPerformancesShort> {

    public data: InternalEquipmentPerformancesShort[];
    
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private totalSubject = new BehaviorSubject<number>(0);
    private performancesSubject = new BehaviorSubject<InternalEquipmentPerformancesShort[]>([]);


    // eslint-disable-next-line @typescript-eslint/member-ordering
    public loading$ = this.loadingSubject.asObservable();
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public totalItems$ = this.totalSubject.asObservable();

    constructor(private service: InternalEquipmentService) {
        this.performancesSubject.subscribe(data => this.data = data);
    }

    connect(_collectionViewer: CollectionViewer): Observable<InternalEquipmentPerformancesShort[]> {
        return this.performancesSubject.asObservable();
    }

    disconnect(_collectionViewer: CollectionViewer): void {
        this.performancesSubject.complete();
        this.loadingSubject.complete();
        this.totalSubject.complete();
    }

    loadInternalEquipmentPerformance(filter = new InternalEquipmentFilterPerformance()): void {

        this.loadingSubject.next(true);

        this.service.findAllPerformance(filter).pipe(
            catchError(() => of([])),
            finalize(() => this.loadingSubject.next(false))
        ).subscribe(data => {
            if (data && data.content) {
                this.performancesSubject.next(data.content as InternalEquipmentPerformancesShort[]);
                this.totalSubject.next(data.totalElements as number);
            } else if (data) {
                this.performancesSubject.next(data as InternalEquipmentPerformancesShort[]);
                this.totalSubject.next(data.length as number);
            } else {
                this.performancesSubject.next([]);
                this.totalSubject.next(0);
            }
        });
    }

}
